import { createFileRoute } from '@tanstack/react-router';
import PlanningPage from '@/pages/planning/planning-page';

export const Route = createFileRoute('/_protected/planning/')({
  component: PlanningPage,
});
